import { PropsWithChildren } from 'react';

import round from 'lodash/round';

import {
  DataPopper,
  DataPopperRow,
  Typography,
  Box,
  Stack,
} from '@cast/design-system';
import { bytesToUnit } from '@cast/utils';

import { DataTooltip } from '@cast/components-data-tooltip';

type Props = {
  egress: number;
  ingress: number;
};

export const TrafficDetailsTooltip = ({
  egress,
  ingress,
  children,
}: PropsWithChildren<Props>) => {
  const total = egress + ingress;

  const [egressValue, egressUnit] = bytesToUnit(egress, 3);
  const [ingressValue, ingressUnit] = bytesToUnit(ingress, 3);

  const egressPercentage = (egress * 100) / (total || 1);
  const ingressPercentage = (ingress * 100) / (total || 1);

  return (
    <DataTooltip
      title={
        <DataPopper
          size="small"
          sx={{ width: 210 }}
          testId="traffic-details-tooltip-popper"
        >
          <DataPopperRow
            indicator={{
              color: 'indigo.200',
              variant: 'filled',
              size: 'small',
            }}
            left={<Typography variant="P10R">Egress</Typography>}
            right={
              <Stack direction="row" gap={24}>
                <Typography variant="P10R">
                  {egressValue} {egressUnit}
                </Typography>

                <Typography variant="P10R" color="textSecondary">
                  {round(egressPercentage, 2)}%
                </Typography>
              </Stack>
            }
          />

          <DataPopperRow
            indicator={{
              color: 'grey.700',
              variant: 'filled',
              size: 'small',
            }}
            left={<Typography variant="P10R">Ingress</Typography>}
            right={
              <Stack direction="row" gap={24}>
                <Typography variant="P10R">
                  {ingressValue} {ingressUnit}
                </Typography>

                <Typography variant="P10R" color="textSecondary">
                  {round(ingressPercentage, 2)}%
                </Typography>
              </Stack>
            }
          />
        </DataPopper>
      }
      placement="top"
      disableHoverListener={!total}
    >
      <Box
        data-testid="network-cost-details-cell"
        flexGrow={1}
        maxWidth={220}
        minHeight={8}
      >
        {children}
      </Box>
    </DataTooltip>
  );
};
